import { getProfessionalCampaigns } from './GetProfessionalCampaigns';

export const CampaignsApi = {
  getProfessionalCampaigns,
};
